var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "LoadingOverlay",
    {
      attrs: {
        loading: _vm.$apollo.queries.conversation.loading,
        hasData:
          !!_vm.conversation || !_vm.$apollo.queries.conversation.loading,
      },
    },
    [
      _c(
        "div",
        { staticClass: "flex w-full overflow-hidden -mt-3" },
        [
          !_vm.conversation
            ? _c(
                "EmptyListPlaceholder",
                {
                  attrs: { title: _vm.noConversationsPlaceholder },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "image",
                        fn: function () {
                          return [_c("EmptyListImageInbox")]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1693747661
                  ),
                },
                [
                  _c("UiButton", {
                    attrs: {
                      buttonText: "New Conversation",
                      id: "newConversation",
                      size: undefined,
                    },
                    on: { click: _vm._createConversation },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "icon",
                          fn: function () {
                            return [
                              _c("PlusIcon", { staticClass: "w-2.5 h-2.5" }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1082581067
                    ),
                  }),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "inbox-window flex w-full" },
                [
                  _c("InboxWindow", {
                    staticClass: "w-full border-primary-color",
                    attrs: {
                      conversation: _vm.conversation,
                      canLeave: false,
                      selectedConversationId: _vm.conversation.id,
                      currentUserId: _vm.currentUser.id,
                      predefinedMessage: "",
                      currentUser: _vm.currentUser,
                      uploadingAttachmentId: _vm.uploadingAttachmentId,
                    },
                    on: { newMessage: _vm.sendMessage },
                  }),
                ],
                1
              ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }